module.exports = __webpack_public_path__ + "top_page/industry-service-b7ca204054e187acf12e3cb4cc2ac502.svg";